
import moment from 'moment';
import React, { useEffect, useState } from 'react';
import DatePicker from 'react-datepicker';

import { Data } from 'service/util';
import MediaTypeDropdown from 'component/dropdown/MediaTypeDropdown';

export const EInvoicingAuditFilter = ({
  filter, staffList, onQuery, onFilter, showFilters
}) => {

  const [from_dtm,   setFromDate ] = useState(new Date());
  const [to_dtm,     setToDate   ] = useState(new Date());
  const [staff,      setStaff    ] = useState(filter.staff);
  const [company,    setCompany  ] = useState(filter.company);
  const [cd_license, setLicense  ] = useState(filter.cd_license);
  const [media_type, setMediaType] = useState(filter.media_type);

  useEffect(() => {
    onFilter({ staff, company, cd_license, media_type});
  }, [staff, company, cd_license, media_type]);

  useEffect(() => {
    onQuery({ from_dtm, to_dtm });
  }, [from_dtm, to_dtm]);

  return (
    <div className="row search-bar">
      <label className="field-row">
        <strong>由</strong>
        <DatePicker selected={from_dtm} onChange={setFromDate}
          minDate={moment('today').add(-1, 'year').startOf('month').toDate()}
          maxDate={moment('today').startOf('day').toDate()}
          dateFormat="yyyy-MM-dd" />
      </label>
      <label className="field-row">
        <strong>至</strong>
        <DatePicker selected={to_dtm} onChange={setToDate}
          minDate={moment(from_dtm)}
          maxDate={moment('today').endOf('day').toDate()}
          dateFormat="yyyy-MM-dd" />
      </label>
      { !showFilters &&
        <label className="field-row">
          <strong>負責同事</strong>
          <select value={staff} onChange={e=>setStaff(e.target.value)}>
            <option value="">全部</option>
            { staffList?.map(s =>
              <option key={s} value={s}>{ s }</option>
            )}
          </select>
        </label>
      }
      { showFilters && <>
        <label className="field-row">
          <strong>公司</strong>
          <select value={company} onChange={e=>setCompany(e.target.value)}>
            <option value="">全部</option>
            { Data.company.map(com =>
              <option key={com.cd} value={com.cd}>{com.cd} - {com.name}</option>
            )}
          </select>
        </label>
        <label className="field-row">
          <strong>車牌</strong>
          <input value={cd_license} onChange={e=>setLicense(e.target.value)} />
        </label>
        <label className="field-row">
          <strong>媒體類型</strong>
          <MediaTypeDropdown value={media_type} onChange={setMediaType} />
        </label>
      </>}
    </div>
  );
}

export default EInvoicingAuditFilter;